const handler = tracker => ({
  trackLocalCouncilTab: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de consejo local", metadata)
  }
})

export default handler